export default __webpack_public_path__ + "static/LPHowToStartImage2-e3eee89b459f818f1fec6046b8439a92.jpg";